import "../sentry.client.config";
import { setCompatRouterNavigate } from "@src/shims/next/router-runtime";
import { RouterProvider } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";
import { router } from "./router";

setCompatRouterNavigate((href, replace, options) => {
  const isExternal = href.startsWith("http");

  return router.navigate({
    to: !isExternal ? href : undefined,
    href: isExternal ? href : undefined,
    replace,
    reloadDocument: options?.shallow === false,
    resetScroll: options?.scroll === false,
  });
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <RouterProvider router={router} />,
);
